import React, { useState, useRef } from 'react'

import useSingleton from '../../../business-components/useSingleton/useSingleton'

import { ValidatorForm } from 'react-material-ui-form-validator'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import MESSAGE from '../../../business-const/Message/Message'

import AuthService from '../../../business-api/AuthService'

import {
    nvl,
    formataValor,
    formataCelular,
} from '../../../business-components/Formata/Formata'

//import {
//    CardGridDividerElementos,
//} from '../../../business-components/Card/Card'

import { 
    IsXsDownScreen
} from '../../../business-components/Service/GlobalService'

import {
    celularOK,
    emailOK,
} from '../../../business-components/RegExp/RegExp'

import {
    round
} from '../../../business-components/round/round'

import {
    GridContainer,
    GridItem1,
    GridItem3xs6,
    GridItem3xs12,
    GridItem4xs12,
    GridItem5xs12,
    GridItem6xs12,
    GridItem7xs12,
    GridItem11,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    CardGridDividerElementos,
} from '../../../business-components/Card/Card'

import {
    TextValidatorEmailRequired,
    TextValidatorCelularRequired,
} from '../../../business-components/TextValidator/TextValidator'

import {
    RichTextEditorViewerPadrao
} from '../../../business-components/RichTextEditor/RichTextEditorViewerPadrao'

import {
    ButtonVisualizarParcelas,
} from '../../../business-components/Button/Button'

import {
    CustomizedDialogsPopup,
} from '../../../business-components/Dialog/CustomizeDialogs'

import {
    SvgIndependenciaFinanceira,
} from '../../../business-components/SvgImage/SvgImage'

import {
    WhatsApp
} from '../../../business-components/WhatsApp/WhatsApp'

import {
    pesquisaList
} from '../../../business-rules/List/ListService'

import {
    dadosCompletosCliente,
    calculaIdadesDataSimulacao,
} from '../cliente-form/ClienteService'

import {
    incluirContato,
} from '../cadastro-form/CadastroServiceContato'

import {
    inicializaEstudo,
    processaCalculoEstudo
} from '../estudo-form/EstudoServiceCalculo'

import {
    processaCenariosDefaultJsonUsuario,
} from '../estudo-parametros/EstudoServiceCenarios'

import {
    identificaIdPergunta,
    valorPerguntaIdentificaId,
    idListPerguntaIdentificaId,
    celularPergunta,
} from '../form-form/FormServicePerguntas'

import {
    NomeCliente,
    NascimentoCliente,
    SexoCliente,
} from '../cadastro-form/CadastroCompCliente'

import {
    incluirFunisEtapas,
} from '../cliente-form/ClienteServiceCliente'

import {
    trataTelefone,
    trataEmail,
} from '../cliente-form/ClienteServiceImportacao'

import {
    processaRegistrosDefaultIniciaisObjConsorcio,
} from '../consorcio-form/ConsorcioServiceSimulacao'

import {
    calculaTotaisReceitaMensal,
} from '../garantias-form/GarantiasServiceReceitaMensal'

import {
    calculaTotaisDiaDia,
} from '../despesas-form/DespesasServiceDiaDia'

import {
    calculaTotaisPatrimonioImobilizado,
} from '../garantias-form/GarantiasServicePatrimonioImobilizado'

import {
    calculaTotaisRecursosFinanceiros,
} from '../garantias-form/GarantiasServiceRecursosFinanceiros'

import {
    AposentadoriaExpectativaVidaCliente,
} from '../simulacaoFinanceira-form/SimulacaoFinanceiraCompParametros'

import {
    CustomizedDialogsPopupDiagnosticoAposentadoriaIndependenciaFinanceira,
} from '../simulacaoFinanceira-form/SimulacaoFinanceiraCompHipotesesFinanceiras'

import ConsorcioFormSimulacaoItemReport from '../consorcio-form/ConsorcioFormSimulacaoItemReport'

import FormFormPerguntas from '../form-form/FormFormPerguntas'



const CaptacaoLeadsFormInclusao = ( { variaveisGlobais, values, handleChange, handleSubmit, setFieldValue,
    handleSubmitAutomatico, vars/*linhaTipoLicenca,*/ /*idConfiguracao, *//*jsonConfiguracao, jsonUsuario, jsonUsuarioAdmin*/,
        linhaFormList, jsonIntegracao, arquivoList, obterArquivoList } ) => {

    //if (tabClienteFormList === LABEL.tabClienteFormListPrevidenciaPrivada) {
    
    //    processaValoresDefaultIniciaisClienteConjuge(values)
    //}
    const estudo = useRef(null)

    const [visualizouGrafico, setVisualizouGrafico] = useState(false)
    
    //const [reexibir, setReexibir] = useState(1)



    useSingleton(async () => {

        if (jsonIntegracao.nomeCliente) {
        
            values.nomeCliente = jsonIntegracao.nomeCliente
        }

        //if (jsonIntegracao.celularCliente || jsonIntegracao.emailCliente) {

        values.contatos = []

        //if (jsonIntegracao.celularCliente) {

            incluirContato(values, HARDCODE.idFamiliarCliente, HARDCODE.idTipoContatoCelular,
                jsonIntegracao.celularCliente ? trataTelefone(jsonIntegracao.celularCliente) : '')
        //}

        //if (jsonIntegracao.emailCliente) {

            incluirContato(values, HARDCODE.idFamiliarCliente, HARDCODE.idTipoContatoEmail,
                jsonIntegracao.emailCliente ? trataEmail(jsonIntegracao.emailCliente) : '')
        //}
        //}

        values.tipoOrigemCliente = HARDCODE.idTipoOrigemClienteIntegracaoMarketingDigital

        if (jsonIntegracao.linkCaptacaoLeadsOrigem) {

            values.tipoOrigemClienteOutras = jsonIntegracao.linkCaptacaoLeadsOrigem
        }

        if (jsonIntegracao.funil) {

            values.funil = jsonIntegracao.funil

            if (jsonIntegracao.etapa) {

                values.etapa = jsonIntegracao.etapa
            }

            values.dataHoraPrevistaFunilEtapa = null
            values.dataRealizacaoFunilEtapa = null

            incluirFunisEtapas(values)
        }

        if (!jsonIntegracao.tipoLinkCaptacaoLeads) {

            jsonIntegracao.tipoLinkCaptacaoLeads = HARDCODE.tipoLinkCaptacaoLeadsDiagnosticoAposentadoria
        }

        estudo.current = inicializaEstudo(/*vars.jsonConfiguracao*/)
    })
    


    
    const exibirFormulario = () => {

        return dadosCompletosCliente(values) &&
            ((values.contatos[0].contato && celularOK(values.contatos[0].contato, true)) || lgpd()) &&
            values.contatos[1].contato && emailOK(values.contatos[1].contato)
    }

    const exibirGrafico = () => {

        return (
                valorPerguntaIdentificaId(values, HARDCODE.identificaIdPerguntaRendaMensal) ||
                !pesquisaList(values.perguntas, HARDCODE.identificaIdPerguntaRendaMensal).id
            ) &&
            (
                valorPerguntaIdentificaId(values, HARDCODE.identificaIdPerguntaGastoMensal) ||
                !pesquisaList(values.perguntas, HARDCODE.identificaIdPerguntaGastoMensal).id
            ) &&
            valorPerguntaIdentificaId(values, HARDCODE.identificaIdPerguntaRecursosFinanceiros) &&
            (
                valorPerguntaIdentificaId(values, HARDCODE.identificaIdPerguntaPatrimonioImobilizado) ||
                !pesquisaList(values.perguntas, HARDCODE.identificaIdPerguntaPatrimonioImobilizado).id
             ) &&
            valorPerguntaIdentificaId(values, HARDCODE.identificaIdPerguntaRendaAposentadoria)
    }

    const exibirConsorcio = () => {

        return valorPerguntaIdentificaId(values, HARDCODE.identificaIdPerguntaValorCredito) &&
            idListPerguntaIdentificaId(values, HARDCODE.identificaIdPerguntaPessoaFisicaJuridica) &&
            idListPerguntaIdentificaId(values, HARDCODE.identificaIdPerguntaPrazoMeses) &&
            (
                idListPerguntaIdentificaId(values, HARDCODE.identificaIdPerguntaLanceRecursoProprio) ||
                idListPerguntaIdentificaId(values, HARDCODE.identificaIdPerguntaLanceRecursoProprio) === 0
            ) &&
            (
                idListPerguntaIdentificaId(values, HARDCODE.identificaIdPerguntaLanceEmbutido) ||
                idListPerguntaIdentificaId(values, HARDCODE.identificaIdPerguntaLanceEmbutido) === 0
            ) &&
            idListPerguntaIdentificaId(values, HARDCODE.identificaIdPerguntaMesesComprarImovel)
    }

    const formularioSimplificado = () => {

        let formularioSimplificadoAux = true

        vars.jsonUsuario.configuracaoPerguntas?.forEach( (linhaConfiguracaoPerguntas, indexConfiguracaoPerguntas) => {

            if (
                    linhaConfiguracaoPerguntas.descricaoFormulario &&
                    linhaConfiguracaoPerguntas.ativo !== "N" &&
                    linhaConfiguracaoPerguntas.defaultCaptacaoLeads
             ) {

                if (
                        linhaConfiguracaoPerguntas.perguntasExibir.length > 1 ||
                        pesquisaList(linhaFormList.perguntasFormList,
                            parseInt(linhaConfiguracaoPerguntas.perguntasExibir[0].id)).identificaId !==
                                HARDCODE.identificaIdPerguntaRendaAposentadoria
                ) {

                    formularioSimplificadoAux = false
                }
            }
        })

        return formularioSimplificadoAux
    }

    const lgpd = () => {

        let lgpdAux = false

        vars.jsonUsuario.configuracaoPerguntas?.forEach( (linhaConfiguracaoPerguntas, indexConfiguracaoPerguntas) => {

            if (
                    linhaConfiguracaoPerguntas.descricaoFormulario &&
                    linhaConfiguracaoPerguntas.ativo !== "N" &&
                    linhaConfiguracaoPerguntas.defaultCaptacaoLeads
             ) {

                linhaConfiguracaoPerguntas.perguntasExibir?.forEach( (linhaPerguntasExibir, indexPerguntasExibir) => {

                    if (
                        pesquisaList(linhaFormList.perguntasFormList,
                            parseInt(linhaPerguntasExibir.id)).identificaId ===
                                HARDCODE.identificaIdPerguntaLGPDCelular
                    ) {

                        lgpdAux = true
                    }
                })
            }
        })

        return lgpdAux
    }

    const exibirIndependenciaFinanceiraVitalicia = () => {

        return formularioSimplificado() &&
            valorPerguntaIdentificaId(values, HARDCODE.identificaIdPerguntaRendaAposentadoria)
    }



    if (
            (
                !values.id && values.nomeCliente &&
                ((values.contatos[0].contato && celularOK(values.contatos[0].contato, true)) || lgpd()) &&
                values.contatos[1].contato && emailOK(values.contatos[1].contato)
            ) ||
            exibirIndependenciaFinanceiraVitalicia() ||
            (
                jsonIntegracao.tipoLinkCaptacaoLeads === HARDCODE.tipoLinkCaptacaoLeadsQuestionario &&
                exibirFormulario()
            )
    ) {

        handleSubmitAutomatico(values)
    }
    

    
    if (dadosCompletosCliente(values)) {

        calculaIdadesDataSimulacao(values, false)

        calculaTotaisReceitaMensal(values)

        calculaTotaisDiaDia(values, vars.jsonConfiguracao)

        calculaTotaisPatrimonioImobilizado(values)

        calculaTotaisRecursosFinanceiros(values)

        processaCenariosDefaultJsonUsuario(values, vars.jsonUsuario, vars.jsonUsuarioAdmin)

        const retiradaMensalDepoisAposentarCliente =
            valorPerguntaIdentificaId(values, HARDCODE.identificaIdPerguntaRendaAposentadoria)
        
        const recursosFinanceiros =
            valorPerguntaIdentificaId(values, HARDCODE.identificaIdPerguntaRecursosFinanceiros)

        const aporteMensalAntesAposentarCliente =
            valorPerguntaIdentificaId(values, HARDCODE.identificaIdPerguntaAporteAposentadoria)

        if (
                values.retiradaMensalDepoisAposentarCliente !== retiradaMensalDepoisAposentarCliente ||
                values.aporteMensalAntesAposentarCliente !== aporteMensalAntesAposentarCliente ||
                (
                    recursosFinanceiros &&
                    round(estudo.current.panelGarantiasAtuais[
                        HARDCODE.indexEstudoRecursosFinanceiros].valorAcumuladoPainel, 2) !== round(recursosFinanceiros, 2)
                )
        ) {
        
            setFieldValue('retiradaMensalDepoisAposentarCliente', retiradaMensalDepoisAposentarCliente)

            setFieldValue('aporteMensalAntesAposentarCliente', aporteMensalAntesAposentarCliente)
        }

        const celular = celularPergunta(values, identificaIdPergunta(values, HARDCODE.identificaIdPerguntaLGPDCelular))

        if (celular && values.contatos[0].contato !== celular) {

            setFieldValue('contatos[0].contato', celular)
        }

        processaCalculoEstudo(values, handleSubmitAutomatico, estudo, false, true/*false*/,
            HARDCODE.origemCalculoEstudoPrimeiraReuniaoPlanilha, /*true*/false, vars.jsonConfiguracao, false)

        if (exibirConsorcio()) {

            processaRegistrosDefaultIniciaisObjConsorcio(values)

            values.objConsorcio.simulacao[0].administradoraConsorcio = jsonIntegracao.administradoraConsorcio
            values.objConsorcio.simulacao[0].parcelasAdesao = jsonIntegracao.parcelasAdesao
            values.objConsorcio.simulacao[0].taxaAdesao = jsonIntegracao.taxaAdesao
            values.objConsorcio.simulacao[0].taxaAdministracao = jsonIntegracao.taxaAdministracao
            values.objConsorcio.simulacao[0].percFundoReserva = jsonIntegracao.percFundoReserva
            values.objConsorcio.simulacao[0].percSeguroPrestamista = jsonIntegracao.percSeguroPrestamista
            values.objConsorcio.simulacao[0].percRedutorParcela = jsonIntegracao.percRedutorParcela
            values.objConsorcio.simulacao[0].valorCreditoConsorcio =
                valorPerguntaIdentificaId(values, HARDCODE.identificaIdPerguntaValorCredito)
            values.objConsorcio.simulacao[0].pessoaFisicaJuridica =
                idListPerguntaIdentificaId(values, HARDCODE.identificaIdPerguntaPessoaFisicaJuridica)
            values.objConsorcio.simulacao[0].prazoTotalGrupoConsorcio =
                idListPerguntaIdentificaId(values, HARDCODE.identificaIdPerguntaPrazoMeses)
            values.objConsorcio.simulacao[0].percLanceRecursosProprios =
                idListPerguntaIdentificaId(values, HARDCODE.identificaIdPerguntaLanceRecursoProprio)
            values.objConsorcio.simulacao[0].percLanceEmbutido =
                idListPerguntaIdentificaId(values, HARDCODE.identificaIdPerguntaLanceEmbutido)
            values.objConsorcio.simulacao[0].contemplacaoParcela =
                idListPerguntaIdentificaId(values, HARDCODE.identificaIdPerguntaMesesComprarImovel)
        }
    }



    const isXsDownScreen = IsXsDownScreen()

    const GridIndependenciaFinanceira = isXsDownScreen ? GridItem12 : GridItem11



    return (
        <ValidatorForm 
            onSubmit={handleSubmit}
            onError={
                () => null
            }
        >
            <div
                align='left'
            >
                {!exibirGrafico() &&
                !formularioSimplificado() &&
                jsonIntegracao.tipoLinkCaptacaoLeads === HARDCODE.tipoLinkCaptacaoLeadsDiagnosticoAposentadoria && (
                    <>
                        <GridContainer
                            className='mt-0'
                        >
                            <GridItem6xs12
                                className={isXsDownScreen ? '' : 'mt-10'}
                            >
                                <GridContainer>
                                    <GridIndependenciaFinanceira>
                                        <SvgIndependenciaFinanceira
                                            //fontSize="small"
                                        />
                                    </GridIndependenciaFinanceira>

                                    {!isXsDownScreen && (
                                        <GridItem1/>
                                    )}
                                </GridContainer>
                            </GridItem6xs12>

                            <GridItem6xs12
                                align='left'
                                className='mt-2'
                            >
                                <span
                                    className='text-15 text-muted-strong'
                                    dangerouslySetInnerHTML={{
                                        __html: MESSAGE().capitacaoLeadsPreencherDados.replace('$expectativaVidaClienteConjuge$',
                                                    nvl(values.idadeFinalVitalicioClienteConjuge, 90))}}
                                />
                            </GridItem6xs12>
                        </GridContainer>

                        {/*
                        <CardGridDividerElementos
                            className={exibirFormulario() ? 'mt--5' : 'mt-5'}
                        />
                        */}
                    </>
                )}

                <GridContainer
                    className='mt-5'
                >
                    <GridItem5xs12>
                        <NomeCliente
                            values={values}
                            handleChange={handleChange}
                            jsonConfiguracao={vars.jsonConfiguracao}
                            captacaoLeads={true}
                        />
                    </GridItem5xs12>

                    {(!jsonIntegracao.emailCliente || !emailOK(jsonIntegracao.emailCliente)) && (
                        <GridItem4xs12>
                            <TextValidatorEmailRequired
                                name={`contatos[1].contato`}
                                label={LABEL.email}
                                value={values.contatos[1].contato || ''}
                                onChange={handleChange}
                            />
                        </GridItem4xs12>
                    )}

                    {(!jsonIntegracao.celularCliente || !celularOK(jsonIntegracao.celularCliente, true)) && !lgpd() &&(
                        <GridItem3xs6>
                            <TextValidatorCelularRequired
                                name={`contatos[0].contato`}
                                label={LABEL.celular}
                                value={values.contatos[0].contato || ''}
                                onChange={handleChange}
                                validarTamanho11={true}
                            />
                        </GridItem3xs6>
                    )}
                </GridContainer>

                {values.nomeCliente &&
                ((values.contatos[0].contato && celularOK(values.contatos[0].contato, true)) || lgpd()) &&
                values.contatos[1].contato && emailOK(values.contatos[1].contato) && (
                    <GridContainer
                        className='mt-2'
                    >
                        <GridItem5xs12>
                            <GridContainer>
                                <NascimentoCliente
                                    values={values}
                                    setFieldValue={setFieldValue}
                                    required={true}
                                />

                                <GridItem6xs12
                                    className='mt-2'
                                >
                                    <SexoCliente
                                        values={values}
                                        handleChange={handleChange}
                                    />
                                </GridItem6xs12>

                                {/*
                                <IdadeCliente
                                    values={values}
                                    handleChange={handleChange}
                                />
                                */}
                            </GridContainer>
                        </GridItem5xs12>

                        {dadosCompletosCliente(values) &&
                        jsonIntegracao.tipoLinkCaptacaoLeads === HARDCODE.tipoLinkCaptacaoLeadsDiagnosticoAposentadoria && (
                            <GridItem7xs12
                                className='mt-2'
                            >
                                <AposentadoriaExpectativaVidaCliente
                                    values={values}
                                    setFieldValue={setFieldValue}
                                />

                                <GridContainer
                                    className='mb-5'
                                >
                                    <GridItem12
                                        align='center'
                                    >
                                        <span
                                            className={'text-muted ' + (isXsDownScreen ? 'text-11' : 'text-13')}
                                            dangerouslySetInnerHTML={{
                                                __html: MESSAGE().capitacaoLeadsIdades}}
                                        />
                                    </GridItem12>
                                </GridContainer>
                            </GridItem7xs12>
                        )}
                    </GridContainer>
                )}

                {exibirFormulario() && (
                    <>
                        <FormFormPerguntas
                            variaveisGlobais={variaveisGlobais}
                            values={values}
                            handleChange={handleChange}
                            handleSubmit={handleSubmit}
                            setFieldValue={setFieldValue}
                            handleSubmitAutomatico={handleSubmitAutomatico}
                            vars={vars}
                            //linhaTipoLicenca={vars.linhaTipoLicenca}
                            //idConfiguracao={idConfiguracao}
                            //jsonConfiguracao={vars.jsonConfiguracao}
                            //jsonUsuario={vars.jsonUsuario}
                            //jsonUsuarioAdmin={vars.jsonUsuarioAdmin}
                            linhaFormList={linhaFormList}
                            completo={false}
                            jsonIntegracao={jsonIntegracao}
                            arquivoList={arquivoList}
                            obterArquivoList={obterArquivoList}
                        />

                        {exibirGrafico() && visualizouGrafico && (
                            <GridContainer
                                className='mt-10'
                            >

                                <GridItem12
                                    align='left'
                                >
                                    <span
                                        className='text-17 text-muted-strong'
                                        dangerouslySetInnerHTML={{
                                            __html:
                                                MESSAGE().capitacaoLeadsContactarUsuarioCelular
                                                    .replace('$nomeCurtoCelularEmail$', '<b>' + vars.jsonUsuario.nomeCurto + '</b>: ' +
                                                        AuthService.obterEmailUsuarioLogado(variaveisGlobais) + ' - ' +
                                                            formataCelular(vars.jsonUsuario.celular)),
                                        }}
                                    />

                                    <WhatsApp
                                        numero={vars.jsonUsuario.celular}
                                        svgIconButtonFontSize='large'
                                    />

                                    {((vars.jsonUsuario.textoCaptacaoLeadsPlanejamentoCompleto &&
                                    vars.jsonUsuario.textoCaptacaoLeadsPlanejamentoCompleto !== HARDCODE.richTextEditorVazio) ||
                                    (vars.jsonConfiguracao.textoCaptacaoLeadsPlanejamentoCompleto &&
                                    vars.jsonConfiguracao.textoCaptacaoLeadsPlanejamentoCompleto !== HARDCODE.richTextEditorVazio))
                                        ?
                                            <RichTextEditorViewerPadrao
                                                content={
                                                    (vars.jsonUsuario.textoCaptacaoLeadsPlanejamentoCompleto &&
                                                    vars.jsonUsuario.textoCaptacaoLeadsPlanejamentoCompleto !== HARDCODE.richTextEditorVazio
                                                        ?
                                                            vars.jsonUsuario.textoCaptacaoLeadsPlanejamentoCompleto
                                                        :
                                                            vars.jsonConfiguracao.textoCaptacaoLeadsPlanejamentoCompleto
                                                    ).replace('$nomeCurto$', vars.jsonUsuario.nomeCurto)}
                                            />
                                        :
                                            <span
                                                className='text-17 text-muted-strong'
                                                dangerouslySetInnerHTML={{
                                                    __html:
                                                        MESSAGE().capitacaoLeadsContactarUsuarioAnalisar
                                                            .replace('$nomeCurto$', vars.jsonUsuario.nomeCurto),
                                                }}
                                            />
                                    }
                                </GridItem12>
                            </GridContainer>
                        )}

                        {exibirIndependenciaFinanceiraVitalicia() && (
                            <div>
                                <CardGridDividerElementos/>

                                <div
                                    className='text-18 text-muted-strong mt-8'
                                    dangerouslySetInnerHTML={{
                                        __html:
                                            MESSAGE().capitacaoLeadsIndependenciaFinanceiraVitalicia
                                                .replace('$aporteMensalAdicionalPreservarReservaAposentadoria$',
                                                    formataValor(values.aporteMensalAdicionalPreservarReservaAposentadoria, 2))
                                                .replace('$retiradaMensalDepoisAposentarCliente$',
                                                    formataValor(round(values.retiradaMensalDepoisAposentarCliente, 2), 2)),
                                    }}
                                />
                            </div>
                        )}

                        <GridContainer
                            className='mt-5 justify-center'
                        >
                            {exibirGrafico() && (
                                <GridItem3xs12>
                                    <CustomizedDialogsPopupDiagnosticoAposentadoriaIndependenciaFinanceira
                                        values={values}
                                        handleSubmitAutomatico={handleSubmitAutomatico}
                                        setFieldValue={setFieldValue}
                                        estudo={estudo}
                                        maxWidth='xl'
                                        fullScreen={isXsDownScreen}
                                        close={
                                            () => setVisualizouGrafico(true)
                                        }
                                        //onClose={
                                        //    () => {
                                        //        handleSubmitAutomatico(values)
                                        //        setFieldValue('nomeCliente', values.nomeCliente) // Forçar atualização botão Salvar
                                        //    }
                                        //}
                                    />
                                </GridItem3xs12>
                            )}

                            {exibirConsorcio() && (
                                <GridItem3xs12>
                                    <CustomizedDialogsPopup
                                        maxWidth={isXsDownScreen ? 'xl' : 'md'}
                                        fullScreen={isXsDownScreen}
                                        popupTitle={LABEL.parcelas}
                                        PopupButton={ButtonVisualizarParcelas}
                                        popupComponent={
                                            <ConsorcioFormSimulacaoItemReport
                                                values={values}
                                                item={values.objConsorcio.simulacao[0]}
                                                report={false}
                                            />
                                        }
                                        onOpen={
                                            () => {
                                                handleSubmitAutomatico(values)
                                            }
                                        }
                                        close={
                                            () => setVisualizouGrafico(true)
                                        }
                                    />
                                </GridItem3xs12>
                            )}
                         </GridContainer>
                    </>
                )}
            </div>
        </ValidatorForm>
    )
}

export default CaptacaoLeadsFormInclusao